import { useTrans } from "@/translations";

import React from "react";

import "./TextInputField.css";

const TextInputField = React.forwardRef(
  ({ placeholder, value, onChange, extraClass, readOnly }: any, ref: any) => {
    const className = [
      "text-input-field",
      extraClass,
      readOnly ? "readOnly" : undefined,
    ]
      .filter((x) => x)
      .join(" ");
    const { t } = useTrans();
    return (
      <label className={className}>
        <input
          ref={ref}
          type="text"
          placeholder={placeholder && t(placeholder)}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          data-1p-ignore
        />
      </label>
    );
  },
);

export default TextInputField;
